// state  1-进行中 2-未开始 3-已完成
// priority 优先级 1-10级 1级最高 10级最低
const data = {
  items:[
  ]
}

export default data;